import React from 'react'

const TextSkeleton = ({ width = '30%', height = '10px' }) => {
    return (
        <div className='animate-pulse bg-gray-300 rounded-xl' style={{ width, height }}></div>
    )
}

export default TextSkeleton